import './scss/pages/page-blog-single.scss';

/**
 * News
 */
import { PostsSlider } from './js/front/components/PostsSlider';
new PostsSlider( '.js-posts-slider' );
